<div class="text" [class.selected]="selected">
  {{ text }}
</div>
